import { createAction, props } from '@ngrx/store';

import { CriminalRecordCheckDocument, UserCriminalRecordCheck } from '@models';

// Create CriminalRecordCheckDocument:
export const createCriminalRecordCheckDocument = createAction(
  '[CriminalRecordCheck] Create Initiated',
  props<{
    criminalRecordCheckDocument: CriminalRecordCheckDocument;
    file?: File;
  }>()
);
export const createCriminalRecordCheckDocumentSuccess = createAction(
  '[CriminalRecordCheck] Create Success',
  props<{ criminalRecordCheckDocument: CriminalRecordCheckDocument }>()
);
export const createCriminalRecordCheckDocumentFailed = createAction(
  '[CriminalRecordCheck] Create Failed',
  props<{ error: Error }>()
);

// Fetch CriminalRecordCheckDocument:
export const fetchLatestCriminalRecordCheckDocument = createAction(
  '[CriminalRecordCheck] Fetch Initiated'
);
export const fetchLatestCriminalRecordCheckDocumentSuccess = createAction(
  '[CriminalRecordCheck] Fetch Success',
  props<{ criminalRecordCheckDocument: CriminalRecordCheckDocument }>()
);
export const fetchLatestCriminalRecordCheckDocumentFailed = createAction(
  '[CriminalRecordCheck] Fetch Failed',
  props<{ error: Error }>()
);

// Update CriminalRecordCheckDocument:
export const updateCriminalRecordCheckDocument = createAction(
  '[CriminalRecordCheck] Update Initiated',
  props<{
    criminalRecordCheckDocument: CriminalRecordCheckDocument;
    file?: File;
  }>()
);
export const updateCriminalRecordCheckDocumentSuccess = createAction(
  '[CriminalRecordCheck] Update Success',
  props<{
    criminalRecordCheckDocument: CriminalRecordCheckDocument;
  }>()
);
export const updateCriminalRecordCheckDocumentFailed = createAction(
  '[CriminalRecordCheck] Update Failed',
  props<{ error: Error }>()
);

// Delete CriminalRecordCheckDocument:
export const deleteCriminalRecordCheckDocument = createAction(
  '[CriminalRecordCheck] Delete Initiated',
  props<{ id: string }>()
);
export const deleteCriminalRecordCheckDocumentSuccess = createAction(
  '[CriminalRecordCheck] Delete Success',
  props<{ id: string }>()
);
export const deleteCriminalRecordCheckDocumentFailed = createAction(
  '[CriminalRecordCheck] Delete Failed',
  props<{ error: Error }>()
);

// Upload Processed UserCriminalRecordCheckDocument:
export const uploadProcessedUserCriminalRecordCheckDocument = createAction(
  '[CriminalRecordCheck] Upload Processed Initiated',
  props<{
    userCriminalRecordCheck: UserCriminalRecordCheck;
    file?: File;
  }>()
);
export const uploadProcessedUserCriminalRecordCheckDocumentSuccess = createAction(
  '[CriminalRecordCheck] Upload Processed Success',
  props<{ userCriminalRecordCheck: UserCriminalRecordCheck }>()
);
export const uploadProcessedUserCriminalRecordCheckDocumentFailed = createAction(
  '[CriminalRecordCheck] Upload Processed Failed',
  props<{ error: Error }>()
);